/**
 * Deployment-specific wording, in one place.
 *
 * `ACCESS_REQUEST_EMAIL` is where the "Request access" button on the no-access
 * page sends people. Empty hides the button.
 */
export const ACCESS_REQUEST_EMAIL: string = ''
